import React, { createContext, useState, useEffect } from 'react';

const userList = [
  { name: "Sona", loggedIn: false, pass: '123', role: "admin" },
  { name: "Reside", loggedIn: false, pass: '1234', role: "user" },
  { name: "Terlan", loggedIn: false, pass: '123', role: "user" }
];

export const Context = createContext();

export default function ContextApi({ children }) {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : { name: '', loggedIn: false, role: "", userId: '' };
  });

  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(user));
  }, [user]);

  return (
    <Context.Provider value={{ user, setUser }}>
      {children}
    </Context.Provider>
  );
}
